var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-center d-block pa-3 pa-md-6 pa-lg-12"},[_c('h1',{staticClass:"display-1 mb-2"},[_vm._v("Cette demande d'inscription a déjà été validée.")]),_c('p',{staticClass:"body-1"},[_vm._v("Pour la modifier ou si cette demande ne devrait pas être validée, communiquez avec l'OTSTCFQ.")])])
}]

export { render, staticRenderFns }